module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/shared/siteblocks_new.svg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/shared/siteblocks_new.svg
// module id = 6ZAQ
// module chunks = 0